module.exports = __webpack_public_path__ + "static/media/reentalmoose2.99fdd8fe.png";